<template>
  <header id="header">
    <!--<a href="/" id="header__text">しるQ</a>-->
    <a href="/" id="header__text"><img src="./../assets/siruq.png" width="auto" height="27" alt="test"> </a>
  </header>
</template>

<script>
    export default {
        name: "Header"
    }
</script>

<style scoped>
  #header{
    box-shadow: 0px 3px 25px rgba(77,77,99,0.1);
    z-index: 99;
    top: 0;
    left: 0;
    height: 45px;
    width: 100%;
    background: #fff;
    font-size: 14px;
    display: -webkit-flex;
    display: flex;
    -webkit-align-items: center; /* 縦方向中央揃え（Safari用） */
    align-items: center; /* 縦方向中央揃え */
    -webkit-justify-content: center; /* 横方向中央揃え（Safari用） */
    justify-content: center; /* 横方向中央揃え */
    margin-bottom: 25px;
    padding-top: 5px;
  }
  #header__text{

  }
  a {
    color:#0e0e25;
    text-decoration:none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue